'use client'

import { captureAnalyticsEvent } from '@/lib/analytics'
import { useEffect } from 'react'

export function ExperienceViewTracker({
  experienceSlug,
  experienceName,
  destination,
}: {
  experienceSlug: string
  experienceName: string
  destination?: string
}) {
  useEffect(() => {
    captureAnalyticsEvent('experience_viewed', {
      experience_slug: experienceSlug,
      experience_name: experienceName,
      destination,
    })
  }, [destination, experienceName, experienceSlug])

  return null
}
